import React from "react";
import PropTypes from "prop-types";
import UserMessage from "./user";
import PollMessage from "./system/poll";
import VideoMessage from "./system/video";
import { ID, MESSAGE_HIDDEN } from "utils/constants";
import { getMessageType } from "utils/data";
import storage from "utils/data/storage";
import "./index.scss";

const propTypes = {
  currentIndex: PropTypes.number,
  setRef: PropTypes.func,
};

const defaultProps = {
  currentIndex: 0,
  setRef: () => {},
};

const Messages = ({ currentIndex, setRef }) => {
  return (
    <div className="list">
      <div className="message-wrapper">
        {storage.messages.map((item, index) => {
          const active = index <= currentIndex;
          const { timestamp, message } = item;
          const type = getMessageType(item);
          const isMessageFaceDetect =
            typeof message === "string" &&
            MESSAGE_HIDDEN.some((word) => message.trim().startsWith(word));
          if (isMessageFaceDetect)
            return <span ref={(node) => setRef(node, index)} />;
          switch (type) {
            case ID.USERS:
              return (
                <span
                  ref={(node) => setRef(node, index)}
                  key={`message-item--${index}`}
                >
                  <UserMessage
                    active={active}
                    emphasized={item.emphasized}
                    hyperlink={item.hyperlink}
                    initials={item.initials}
                    moderator={item.moderator}
                    name={item.name}
                    text={item.message}
                    timestamp={timestamp}
                  />
                </span>
              );
            case ID.POLLS:
              return (
                <span
                  ref={(node) => setRef(node, index)}
                  key={`message-item--${index}`}
                >
                  <PollMessage
                    active={active}
                    answers={item.answers}
                    question={item.question}
                    responders={item.responders}
                    timestamp={timestamp}
                    type={item.type}
                  />
                </span>
              );
            case ID.VIDEOS:
              return (
                <span
                  ref={(node) => setRef(node, index)}
                  key={`message-item--${index}`}
                >
                  <VideoMessage
                    active={active}
                    url={item.url}
                    timestamp={timestamp}
                    type={item.type}
                  />
                </span>
              );
            default:
              return <span ref={(node) => setRef(node, index)} />;
          }
        })}
      </div>
    </div>
  );
};

Messages.propTypes = propTypes;
Messages.defaultProps = defaultProps;

export default Messages;
